import { render, staticRenderFns } from "./HaveAttempts.vue?vue&type=template&id=201b4b3a&scoped=true&"
import script from "./HaveAttempts.vue?vue&type=script&lang=js&"
export * from "./HaveAttempts.vue?vue&type=script&lang=js&"
import style0 from "./HaveAttempts.vue?vue&type=style&index=0&id=201b4b3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201b4b3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
